import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Card } from "react-bootstrap";

function StepComplete(props) {
  return (
    <Card>
      <div className="complete-page dis-flex-col">
        <div className="img">
          <img src="/complete-steps.webp" alt="complete" />
        </div>
        <dic className="heading">Congratulations !</dic>
        <div className="desc">
          You are now a part of Toolsvilla Seller Community,
          <br /> Sell all over India
        </div>
        <NavLink to="/products">
          <button>Add new products</button>
        </NavLink>
      </div>
    </Card>
  );
}

export default StepComplete;
